export function getOwnerDocument(el: Element | undefined | null): Document {
  return el?.ownerDocument || document;
}
